import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, AbstractControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material';
import { ChangepasswordService } from 'src/app/_services/admin/changepassword.service';
import { environment } from '../../../../environments/environment';
import { isNullOrUndefined } from 'util';

function ValidateConfirmPassword(c: AbstractControl): any {
  if (!c.parent || !c) {
    return;
  }
  const pwd = c.parent.get('txtNewPassword');
  const cpwd = c.parent.get('txtConfirmPassword');

  if (!pwd || !cpwd) {
    return;
  }

  if (pwd.value !== cpwd.value) {
    return { invalid: true };
  }
}

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  ChangePasswordForm: FormGroup;
  isChangePasswordFormSubmitted = false;

  constructor(private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private myTitle: Title,
    private changepasswordservice: ChangepasswordService) { }

  ngOnInit() {
    this.myTitle.setTitle('Change Password | ' + environment.commonTitle);
    this.ChangePasswordForm = this.formBuilder.group({
      txtOldPassword: [null, [Validators.required]],
      txtNewPassword: [null, Validators.compose([Validators.required,
      Validators.pattern('^(?=[a-zA-Z0-9!@#$^*_]{8,20}$)(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9]).*')])],
      txtConfirmPassword: [null, [Validators.required, ValidateConfirmPassword]],
    });
  }

  changePassword() {
    try {
      this.isChangePasswordFormSubmitted = true;
      if (!this.ChangePasswordForm.valid) {
        return;
      } else {
        const LocalData = localStorage.getItem('member');
        if (!isNullOrUndefined(LocalData)) {
          const userId = JSON.parse(LocalData).id;
          const obj = {
            UserId: userId,
            OldPassword: this.ChangePasswordForm.controls['txtOldPassword'].value,
            NewPassword: this.ChangePasswordForm.controls['txtNewPassword'].value,
            ConfirmPassword: this.ChangePasswordForm.controls['txtConfirmPassword'].value
          };
          this.changepasswordservice.changepassword(obj).subscribe(result => {
            if (result.data) {
              this.isChangePasswordFormSubmitted = false;
              this.ChangePasswordForm.reset();
              this.openSnackBar('Password changed succcessfully.', 'Success');
            }
          }, error => {
            this.openSnackBar(error.error, 'Fail');
          });
        } else {
          this.openSnackBar('Data not found! Please login again to change password.', ' ');
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000
    });
  }
}

